const Features ={
  "title": "Portfolio Features",
  "features": [
    {
      "name": "Dynamic Project Showcase",
      "description": "Real-time displays of creative projects, each with detailed insights and technical breakdowns that reflect real-world experience.",
      "icon": "fas fa-project-diagram"
    },
    {
      "name": "Search and Filter Projects",
      "description": "Easily navigate a curated collection of projects by technology, theme, or level of complexity, ensuring quick access to your areas of interest.",
      "icon": "fas fa-filter"
    },
    {
      "name": "Interactive Project Galleries",
      "description": "Engaging and visual project presentations that bring your work to life through dynamic elements, animations, and responsive design.",
      "icon": "fas fa-images"
    },
    {
      "name": "Responsive Multi-Platform Design",
      "description": "A seamless, adaptive layout that delivers an optimal experience across desktops, tablets, and mobile devices.",
      "icon": "fas fa-laptop-code"
    },
    {
      "name": "Personalized Code Insights",
      "description": "In-depth commentary and breakdowns of coding techniques and problem-solving approaches that showcase your technical journey.",
      "icon": "fas fa-code"
    },
    {
      "name": "Intuitive Navigation",
      "description": "User-centric design principles ensure an easy-to-navigate portfolio where every section is accessible and engaging.",
      "icon": "fas fa-compass"
    },
    {
      "name": "Customizable Content Sections",
      "description": "Flexible, modular layouts allow you to tailor the presentation of your projects and ideas to best reflect your professional narrative.",
      "icon": "fas fa-th-large"
    },
    {
      "name": "Detailed Project Information",
      "description": "Comprehensive project pages provide context, challenges, solutions, and the impact of each work, highlighting the depth of your expertise.",
      "icon": "fas fa-file-alt"
    }
  ]
}
export default Features;